import { withRootStore, withUpdate } from '@polyu-dip/model-core'
import { Instance, types } from 'mobx-state-tree'
import { BaseEntityModel } from './base-entity'
import { NameModel } from './languages-json'
import { TagGroup } from './tag-group.model'

export const TagModel = types
  .compose(BaseEntityModel, NameModel)
  .props({
    id: types.string,
    name: types.string,
    tagGroupId: types.string,
    isDisabled: types.boolean,
    order: types.number,
  })
  .extend(withUpdate)
  .extend(withRootStore)
  .named('TagModel')
  .views((self) => ({
    get tagGroup() {
      if (self.tagGroupId == null) return undefined
      return (
        self.rootStore.masterDataStore as { tagGroups: TagGroup[] }
      ).tagGroups.find((it) => it.id === self.tagGroupId)
    },
  }))

export type Tag = Instance<typeof TagModel>
